export default __webpack_public_path__ + "static/media/hf4.5c833c2b.svg";